import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    triggerFormSubmit, 
    resetFormSubmit, 
    storeFormData, 
    resetFormData,
    setProdotto,
    setTipodicontenitore,
    setSiccurezza,
    setModdiapplicazione,
    setCertificazioni,
    setRaccolta,
    enumRequestStart,
    enumRequestSuccess,
    enumRequestFailure,
    setVarientaDelluva,
    setVarientaVigneto,
  } from "./produzioniFormDataSlice.js";
import produzioniFormApi from "../../services/produzioniFormApi.js";
import { toast } from "react-toastify";




export const fetchProduzioineProdotto = createAsyncThunk(
    "mezziData/fetchMezzo",
    async (_, { dispatch }) => {
      // dispatch(enumRequestStart("mezzo"));
      try {
        const response = await produzioniFormApi.getProdotto();
        // console.log("Tipologia API Response:", response.data.data);
        dispatch(setProdotto(response.data.data)); // Use setTipologia action instead of selectTipologia
        dispatch(enumRequestSuccess("mezzo"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch tipologia.";
        dispatch(
          enumRequestFailure({
            enumType: "prodotto",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );
export const fetchProduzioineTipodicontenitore = createAsyncThunk(
    "mezziData/fetchMezzo",
    async (_, { dispatch }) => {
      // dispatch(enumRequestStart("mezzo"));
      try {
        const response = await produzioniFormApi.getTipoContenitore();
        // console.log("Tipologia API Response:", response.data.data);
        dispatch(setTipodicontenitore(response.data.data)); // Use setTipologia action instead of selectTipologia
        dispatch(enumRequestSuccess("mezzo"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch tipologia.";
        dispatch(
          enumRequestFailure({
            enumType: "prodotto",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );
export const fetchProduzioineSiccurezza = createAsyncThunk(
    "mezziData/fetchMezzo",
    async (_, { dispatch }) => {
      // dispatch(enumRequestStart("mezzo"));
      try {
        const response = await produzioniFormApi.getSiccurezza();
        // console.log("Tipologia API Response:", response.data.data);
        dispatch(setSiccurezza(response.data.data)); // Use setTipologia action instead of selectTipologia
        dispatch(enumRequestSuccess("mezzo"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch tipologia.";
        dispatch(
          enumRequestFailure({
            enumType: "prodotto",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );
export const fetchProduzioineModdiapplicazione = createAsyncThunk(
    "mezziData/fetchMezzo",
    async (_, { dispatch }) => {
      // dispatch(enumRequestStart("mezzo"));
      try {
        const response = await produzioniFormApi.getModApplicazione();
        // console.log("Tipologia API Response:", response.data.data);
        dispatch(setModdiapplicazione(response.data.data)); // Use setTipologia action instead of selectTipologia
        dispatch(enumRequestSuccess("mezzo"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch tipologia.";
        dispatch(
          enumRequestFailure({
            enumType: "prodotto",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );
export const fetchProduzioineCertificazioni = createAsyncThunk(
    "mezziData/fetchMezzo",
    async (_, { dispatch }) => {
      // dispatch(enumRequestStart("mezzo"));
      try {
        const response = await produzioniFormApi.getCertificazioni();
        // console.log("Tipologia API Response:", response.data.data);
        dispatch(setCertificazioni(response.data.data)); // Use setTipologia action instead of selectTipologia
        dispatch(enumRequestSuccess("mezzo"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch tipologia.";
        dispatch(
          enumRequestFailure({
            enumType: "prodotto",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );
export const fetchProduzioineRaccolta = createAsyncThunk(
    "raccoltaData/fetchRaccolta",
    async (_, { dispatch }) => {
      // dispatch(enumRequestStart("raccolta"));
      try {
        const response = await produzioniFormApi.getRaccolta();
        dispatch(setRaccolta(response.data.data));
        dispatch(enumRequestSuccess("raccolta"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch raccolta.";
        dispatch(
          enumRequestFailure({
            enumType: "raccolta",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );

  export const fetchProduzioineVarientaDelluva = createAsyncThunk(
    "varientaDelluvaData/fetchVarientaDelluva",
    async (_, { dispatch }) => {
      // dispatch(enumRequestStart("raccolta"));
      try {
        const response = await produzioniFormApi.getVarientaDelluva();
        dispatch(setVarientaDelluva(response.data.data));
        dispatch(enumRequestSuccess("varientaDelluva"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch varientaDelluva.";
        dispatch(
          enumRequestFailure({
            enumType: "varientaDelluva",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );

  export const fetchProduzioineVarientaVigneto = createAsyncThunk(
    "varientaVignetoData/fetchVarientaVigneto",
    async (_, { dispatch }) => {
      // dispatch(enumRequestStart("raccolta"));
      try {
        const response = await produzioniFormApi.getVarientaVigneto();
        dispatch(setVarientaVigneto(response.data.data));
        dispatch(enumRequestSuccess("varientaVigneto"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch VarientaVigneto.";
        dispatch(
          enumRequestFailure({
            enumType: "varientaVigneto",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );